/**
 * lib/heroSlides.js (r7.7, C4) — the hero feed (GET /placements/hero → hero.slides) in the shape <HeroCarousel/>
 * renders, plus the impression / click beacons (POST /placements/beacon, deduplicated per session).
 *
 *   feed slide  { key, kind: admin|organizer|boost|featured, title, subtitle, image_url, image_url_mobile, link_url,
 *                 event { slug, date, venue_name, price_regular, … }, sponsored, sponsor_name, cta_label, theme }
 *   carousel    { id, key, kind, eyebrow, title, lede, poster_url, image_url, cta_to, cta_label, date, venue_name,
 *                 price_from, sponsored, sponsor_name, theme, is_boosted }
 */
import { api } from './api';

const sent = new Set();

export function toPath(url) {
  if (!url) return null;
  try { const u = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'https://showznticketz.com'); return typeof window !== 'undefined' && u.origin === window.location.origin ? `${u.pathname}${u.search}` : url; } catch { return url; }
}

export function adaptHeroSlides(slides = []) {
  return slides.map((s) => {
    const ev = s.event || {};
    return {
      id: s.id || s.key, key: s.key, kind: s.kind,
      eyebrow: s.sponsored ? (s.sponsor_name ? `Sponsored · ${s.sponsor_name}` : 'Sponsored') : s.kind === 'boost' ? 'Promoted' : s.kind === 'featured' ? 'Featured' : null,
      title: s.title || ev.title || '', lede: s.subtitle || null,
      poster_url: s.image_url_mobile || s.image_url || ev.poster_url || null, image_url: s.image_url || null,
      cta_to: toPath(s.link_url) || (ev.slug ? `/e/${ev.slug}` : null), cta_label: s.cta_label || null,
      date: ev.date || null, venue_name: ev.venue_name || null, price_from: ev.price_regular ?? null, slug: ev.slug || null, event_code: ev.event_code || null,
      sponsored: !!s.sponsored, sponsor_name: s.sponsor_name || null, is_boosted: s.kind === 'boost', theme: s.theme || {},
    };
  });
}

export function beacon({ impressions = [], clicks = [] } = {}) {
  const imp = [...new Set(impressions.filter((k) => k && !sent.has(`i:${k}`)))]; imp.forEach((k) => sent.add(`i:${k}`));
  const clk = [...new Set(clicks.filter(Boolean))];
  if (!imp.length && !clk.length) return Promise.resolve(null);
  return api.post('/api/placements/beacon', { ...(imp.length ? { impressions: imp } : {}), ...(clk.length ? { clicks: clk } : {}) }).catch(() => null);
}

export function resetBeacons() { sent.clear(); }
export default { adaptHeroSlides, beacon, toPath, resetBeacons };
